import { render, staticRenderFns } from "./BaseRequest.vue?vue&type=template&id=9d336e12&scoped=true&"
import script from "./BaseRequest.vue?vue&type=script&lang=js&"
export * from "./BaseRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d336e12",
  null
  
)

export default component.exports